import React from 'react';
import FormWriteReview from './FormWriteReview';
import CommentItem from './CommentItem';
import Helper from './Helper';
import _ from 'lodash';

class ProductReview extends React.Component {

    handleShowForm = (flag)=>{
        this.props.handleShowForm(flag)
    }


    render(){
        let {product, account} = this.props,
        {rating, review} = product;
        let realAvgRating = Math.round(rating.length ? 
        rating.reduce((c,n)=>c+parseInt(n.number), 0)/rating.length
        :0);
        let starRate = [];
        for (let i = 4; i >= 0; i--) {
            let rate = rating.length ? (rating.reduce((c,n)=>{
                return  parseInt(n.number)===(i+1) ? (c+1):c
            },0)/rating.length)*100
            : 0;
            rate = rate - Math.floor(rate) === 0 ? rate: rate.toFixed(2);
            starRate.push(rate);
        }

        let dump_data = product.dump_data;
        let finalRating = realAvgRating;
        let finalRatingCount = rating.length;

        if(!_.isEmpty(dump_data))
        {
            let {star_1, star_2, star_3, star_4, star_5, avg_rating, sell_count} = dump_data;
            let star = [star_1, star_2, star_3, star_4, star_5];
            finalRating = avg_rating;
            finalRatingCount += star_1 + star_2 + star_3 + star_4 + star_5;

            starRate = [];
            for (let i = 4; i >= 0; i--) {
                let rate = (star[i] / finalRatingCount) * 100;
                starRate.push(rate.toFixed(2));
            }
        }

        let ratingView = starRate.map((rate, index)=>{
            if(isNaN(rate)) {
                rate = 0;
            }
            
            return (
            <div key={index} className="d-flex review-rating-box">
                <span>{starRate.length - index} sao</span>
                <div className="review-rating"><div style={{width:`${rate}%`}}></div></div>
                <span>{rate}%</span>
            </div>);
        });


        let ratingStarView = [];
        for (let i = 0; i < 5; i++) {
            let act = finalRating >= (i+1) ? 'star act' : 'star dis';
            ratingStarView.push(
            <span key={i} className={act}>
              <i className="fas fa-star" />
            </span>);
        }

        // for (let i = 0; i < 5; i++) {
        //     let grayscale = finalRating <= i ? 'grayscale':''
        //     ratingStarView.push(
        //     <img key={i}
        //         src={Helper.getSiteUrl() + "/resource/images/ico_star_yellow.svg"}
        //         className={`rating ${grayscale}`}
        //     />);
        // }

        let commentContent = review.length ? review.map((item, index)=>{
            return <CommentItem key={index} review={item} 
                    account={account} product={product} />
        }):null;
        return (
            <div className="col-12 mt-4 row justify-content-start align-items-center">
                <div className="col-12 col-md-4 col-lg-2">
                    <h4 className="text-center">
                        <span className="display-4 font-weight-bold">{finalRating.toFixed(2)}/5</span><br/>
                        {ratingStarView}<br/>
                        <span className="mt-0" style={{fontSize:'1rem'}}>{finalRatingCount} Ratings</span>
                    </h4>
                </div>
                <div className="col-12 col-md-8 col-lg-5">
                    <div>
                        {ratingView}
                    </div>
                </div>
                <div className="col-12 col-lg-5 text-center">
                    <button onClick={()=>this.handleShowForm(true)} className="btn btn_show_review_review" type="button">
                        Viết nhận xét của bạn
                    </button>
                    {this.props.isShowForm ? 
                    <FormWriteReview handleShowForm={this.handleShowForm} 
                    account={account} product={product} />
                    :null}
                </div>
                <div className="col-12">
                    <hr/>
                    <div className="product-review">
                        <h5>Review sản phẩm</h5>
                        
                        <div className="product-review__content mt-4">
                            <ul className="unstyled">
                                {commentContent}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            
        )
    }
}
export default ProductReview;